module.exports = __webpack_public_path__ + "static/img/preliminary-round-header.9f0f5287.png";